import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { ArrowDropDown } from '@mui/icons-material';
import { Helmet } from 'react-helmet';
import { useRootStore } from '../../../stores/rootStore';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

const MAJOR_PROPERTY_TYPES = [
  'BUSINESS',
  'COMMERCIAL',
  'COMMUNITY',
  'FARM',
  'FLATS',
  'HOUSE',
  'LAND',
  'STORAGE_UNIT',
  'UNIT',
];

const MINOR_PROPERTY_TYPES = [
  'ACCOMMODATION_RESTAURANT',
  'AGRICULTURAL_SERVICES',
  'AUTOMOTIVE',
  'BUSINESS_OFFICE_SERVICES',
  'CONSTRUCTION',
  'FISHING AND FORESTRY',
  'FRANCHISE_LICENCES',
  'HEALTH AND EDUCATION',
  'MANUFACTURING',
  'MINING',
  'PERSONAL_OTHER_SERVICES',
  'RETAIL_FOOD',
  'RETAIL_TRADE',
  'TOURIST AND LEISURE_SERVICES',
  'TRANSPORT AND STORAGE',
  'WHOLESALE_TRADE',
  'INDUSTRIAL_BUILDING',
  'OFFICE_BUILDING',
  'RETAIL_BUILDING',
  'CENTRES',
  'EDUCATION',
  'GOVERNMENT',
  'RELIGIOUS',
  'CATTLE_BEEF',
  'CATTLE_DAIRY',
  'GENERAL',
  'GRAIN AND OTHER_CROPS',
  'HOBBY',
  'HORTICULTURE_FRUIT_GROWING',
  'OTHER_LIVESTOCK',
  'POULTRY',
  'SHEEP',
  'BOARDING_HOUSE',
  'SELF_CONTAINED',
  'ACREAGE',
  'DUAL_OCCUPANCY',
  'DUPLEX',
  'MULTI_STOREY',
  'ONE_STOREY_LOWSET',
  'RURAL',
  'SEMI_DETACHED',
  'STANDARD',
  'TERRACE',
  'TWO_STOREY_HIGHSET',
  'INDUSTRIAL',
  'OFFICE_RETAIL',
  'PARKS_RESERVES',
  'RES_ACREAGE',
  'RES_DEVELOPMENT',
  'RES_HOUSE',
  'RURAL_ACREAGE',
  'CAR_SPACES',
  'STORAGE_LOCKER',
  'HIGHRISE',
  'LOWRISE',
  'PENTHOUSE',
  'QUADRAPLEX',
  'STUDIO',
  'TOWNHOUSE_VILLA',
  'TRIPLEX',
];

const PROPERTY_TYPES = [
  [
    'Standardised Property Type',
    'Property Type ID',
    'Property Type Major Code',
    'Property Type Minor Code',
    'Property Type Major Description',
    'Enum Values Property Type Major',
    'Property Type Minor Description',
    'Enum Values Property Type Minor',
    'Is Commercial Flag?',
  ],
  ['Business', '58', 'BU', ' ', 'Business', 'BUSINESS', ' ', ' NULL', 'TRUE'],
  [
    'Business: Accommodation / Restaurant',
    '64',
    'BU',
    '10',
    'Business',
    'BUSINESS',
    'Accommodation / Restaurant',
    'ACCOMMODATION_RESTAURANT',
    'TRUE',
  ],
  [
    'Business: Agricultural Services',
    '65',
    'BU',
    '15',
    'Business',
    'BUSINESS',
    'Agricultural Services',
    'AGRICULTURAL_SERVICES',
    'TRUE',
  ],
  [
    'Business: Automotive',
    '66',
    'BU',
    '17',
    'Business',
    'BUSINESS',
    'Automotive',
    'AUTOMOTIVE',
    'TRUE',
  ],
  [
    'Business: Business / Office Services',
    '67',
    'BU',
    '20',
    'Business',
    'BUSINESS',
    'Business / Office Services',
    'BUSINESS_OFFICE_SERVICES',
    'TRUE',
  ],
  [
    'Business: Construction',
    '68',
    'BU',
    '25',
    'Business',
    'BUSINESS',
    'Construction',
    'CONSTRUCTION',
    'TRUE',
  ],
  [
    'Business: Fishing & Forestry',
    '69',
    'BU',
    '30',
    'Business',
    'BUSINESS',
    'Fishing & Forestry',
    'FISHING AND FORESTRY',
    'TRUE',
  ],
  [
    'Business: Franchise Licences',
    '70',
    'BU',
    '32',
    'Business',
    'BUSINESS',
    'Franchise Licences',
    'FRANCHISE_LICENCES',
    'TRUE',
  ],
  [
    'Business: Health & Education',
    '71',
    'BU',
    '35',
    'Business',
    'BUSINESS',
    'Health & Education',
    'HEALTH AND EDUCATION',
    'TRUE',
  ],
  [
    'Business: Manufacturing',
    '72',
    'BU',
    '40',
    'Business',
    'BUSINESS',
    'Manufacturing',
    'MANUFACTURING',
    'TRUE',
  ],
  [
    'Business: Mining',
    '73',
    'BU',
    '45',
    'Business',
    'BUSINESS',
    'Mining',
    'MINING',
    'TRUE',
  ],
  [
    'Business: Personal / Other Services',
    '74',
    'BU',
    '50',
    'Business',
    'BUSINESS',
    'Personal / Other Services',
    'PERSONAL_OTHER_SERVICES',
    'TRUE',
  ],
  [
    'Business: Retail Food',
    '75',
    'BU',
    '53',
    'Business',
    'BUSINESS',
    'Retail Food',
    'RETAIL_FOOD',
    'TRUE',
  ],
  [
    'Business: Retail Trade',
    '76',
    'BU',
    '55',
    'Business',
    'BUSINESS',
    'Retail Trade',
    'RETAIL_TRADE',
    'TRUE',
  ],
  [
    'Business: Tourist & Leisure Services',
    '77',
    'BU',
    '60',
    'Business',
    'BUSINESS',
    'Tourist & Leisure Services',
    'TOURIST AND LEISURE_SERVICES',
    'TRUE',
  ],
  [
    'Business: Transport & Storage',
    '78',
    'BU',
    '65',
    'Business',
    'BUSINESS',
    'Transport & Storage',
    'TRANSPORT AND STORAGE',
    'TRUE',
  ],
  [
    'Business: Wholesale Trade',
    '79',
    'BU',
    '70',
    'Business',
    'BUSINESS',
    'Wholesale Trade',
    'WHOLESALE_TRADE',
    'TRUE',
  ],
  [
    'Commercial',
    '61',
    'CO',
    ' ',
    'Commercial',
    'COMMERCIAL',
    ' ',
    ' NULL',
    'TRUE',
  ],
  [
    'Commercial: Industrial Building',
    '86',
    'CO',
    '70',
    'Commercial',
    'COMMERCIAL',
    'Industrial Building',
    'INDUSTRIAL_BUILDING',
    'TRUE',
  ],
  [
    'Commercial: Office Building',
    '85',
    'CO',
    '50',
    'Commercial',
    'COMMERCIAL',
    'Office Building',
    'OFFICE_BUILDING',
    'TRUE',
  ],
  [
    'Commercial: Retail Building',
    '84',
    'CO',
    '30',
    'Commercial',
    'COMMERCIAL',
    'Retail Building',
    'RETAIL_BUILDING',
    'TRUE',
  ],
  [
    'Community',
    '62',
    'CM',
    ' ',
    'Community',
    'COMMUNITY',
    ' ',
    ' NULL',
    'FALSE',
  ],
  [
    'Community: Centres',
    '81',
    'CM',
    '20',
    'Community',
    'COMMUNITY',
    'Centres',
    'CENTRES',
    'FALSE',
  ],
  [
    'Community: Education',
    '82',
    'CM',
    '30',
    'Community',
    'COMMUNITY',
    'Education',
    'EDUCATION',
    'FALSE',
  ],
  [
    'Community: Government',
    '83',
    'CM',
    '40',
    'Community',
    'COMMUNITY',
    'Government',
    'GOVERNMENT',
    'FALSE',
  ],
  [
    'Community: Religious',
    '80',
    'CM',
    '10',
    'Community',
    'COMMUNITY',
    'Religious',
    'RELIGIOUS',
    'FALSE',
  ],
  ['Farm', '60', 'FA', ' ', 'Farm', 'FARM', ' ', ' NULL', 'FALSE'],
  [
    'Farm: Cattle Beef',
    '91',
    'FA',
    '25',
    'Farm',
    'FARM',
    'Cattle Beef',
    'CATTLE_BEEF',
    'FALSE',
  ],
  [
    'Farm: Cattle Dairy',
    '92',
    'FA',
    '30',
    'Farm',
    'FARM',
    'Cattle Dairy',
    'CATTLE_DAIRY',
    'FALSE',
  ],
  [
    'Farm: General',
    '95',
    'FA',
    '50',
    'Farm',
    'FARM',
    'General',
    'GENERAL',
    'FALSE',
  ],
  [
    'Farm: Grain & Other Crops',
    '89',
    'FA',
    '15',
    'Farm',
    'FARM',
    'Grain & Other Crops',
    'GRAIN AND OTHER_CROPS',
    'FALSE',
  ],
  ['Farm: Hobby', '87', 'FA', '5', 'Farm', 'FARM', 'Hobby', 'HOBBY', 'FALSE'],
  [
    'Farm: Horticulture / Fruit Growing',
    '88',
    'FA',
    '10',
    'Farm',
    'FARM',
    'Horticulture / Fruit Growing',
    'HORTICULTURE_FRUIT_GROWING',
    'FALSE',
  ],
  [
    'Farm: Other Livestock',
    '94',
    'FA',
    '40',
    'Farm',
    'FARM',
    'Other Livestock',
    'OTHER_LIVESTOCK',
    'FALSE',
  ],
  [
    'Farm: Poultry',
    '90',
    'FA',
    '20',
    'Farm',
    'FARM',
    'Poultry',
    'POULTRY',
    'FALSE',
  ],
  ['Farm: Sheep', '93', 'FA', '35', 'Farm', 'FARM', 'Sheep', 'SHEEP', 'FALSE'],
  ['Flats', '59', 'FL', ' ', 'Flats', 'FLATS', ' ', ' NULL', 'FALSE'],
  [
    'Flats: Boarding House',
    '97',
    'FL',
    '30',
    'Flats',
    'FLATS',
    'Boarding House',
    'BOARDING_HOUSE',
    'FALSE',
  ],
  [
    'Flats: Self Contained',
    '96',
    'FL',
    '10',
    'Flats',
    'FLATS',
    'Self Contained',
    'SELF_CONTAINED',
    'FALSE',
  ],
  ['House', '57', 'HO', ' ', 'House', 'HOUSE', ' ', ' NULL', 'FALSE'],
  [
    'House: Acreage',
    '102',
    'HO',
    '60',
    'House',
    'HOUSE',
    'Acreage',
    'ACREAGE',
    'FALSE',
  ],
  [
    'House: Dual Occupancy',
    '103',
    'HO',
    '70',
    'House',
    'HOUSE',
    'Dual Occupancy',
    'DUAL_OCCUPANCY',
    'FALSE',
  ],
  [
    'House: Duplex',
    '105',
    'HO',
    '85',
    'House',
    'HOUSE',
    'Duplex',
    'DUPLEX',
    'FALSE',
  ],
  [
    'House: Duplex',
    '107',
    'HO',
    '95',
    'House',
    'HOUSE',
    'Duplex',
    'DUPLEX',
    'FALSE',
  ],
  [
    'House: Multi Storey',
    '101',
    'HO',
    '50',
    'House',
    'HOUSE',
    'Multi Storey',
    'MULTI_STOREY',
    'FALSE',
  ],
  [
    'House: One Storey / Lowset',
    '99',
    'HO',
    '10',
    'House',
    'HOUSE',
    'One Storey / Lowset',
    'ONE_STOREY_LOWSET',
    'FALSE',
  ],
  [
    'House: Rural',
    '128',
    'HO',
    '65',
    'House',
    'HOUSE',
    'Rural',
    'RURAL',
    'FALSE',
  ],
  [
    'House: Semi Detached',
    '104',
    'HO',
    '80',
    'House',
    'HOUSE',
    'Semi Detached',
    'SEMI_DETACHED',
    'FALSE',
  ],
  [
    'House: Standard',
    '98',
    'HO',
    '5',
    'House',
    'HOUSE',
    'Standard',
    'STANDARD',
    'FALSE',
  ],
  [
    'House: Terrace',
    '106',
    'HO',
    '90',
    'House',
    'HOUSE',
    'Terrace',
    'TERRACE',
    'FALSE',
  ],
  [
    'House: Two Storey / Highset',
    '100',
    'HO',
    '30',
    'House',
    'HOUSE',
    'Two Storey / Highset',
    'TWO_STOREY_HIGHSET',
    'FALSE',
  ],
  ['Land', '56', 'LA', ' ', 'Land', 'LAND', ' ', ' NULL', 'FALSE'],
  [
    'Land: General',
    '108',
    'LA',
    '5',
    'Land',
    'LAND',
    'General',
    'GENERAL',
    'FALSE',
  ],
  [
    'Land: Government',
    '116',
    'LA',
    '85',
    'Land',
    'LAND',
    'Government',
    'GOVERNMENT',
    'FALSE',
  ],
  [
    'Land: Industrial',
    '114',
    'LA',
    '65',
    'Land',
    'LAND',
    'Industrial',
    'INDUSTRIAL',
    'FALSE',
  ],
  [
    'Land: Office / Retail',
    '113',
    'LA',
    '60',
    'Land',
    'LAND',
    'Office / Retail',
    'OFFICE_RETAIL',
    'FALSE',
  ],
  [
    'Land: Parks / Reserves',
    '115',
    'LA',
    '70',
    'Land',
    'LAND',
    'Parks / Reserves',
    'PARKS_RESERVES',
    'FALSE',
  ],
  [
    'Land: Res Acreage',
    '110',
    'LA',
    '20',
    'Land',
    'LAND',
    'Res Acreage',
    'RES_ACREAGE',
    'FALSE',
  ],
  [
    'Land: Res Development',
    '112',
    'LA',
    '50',
    'Land',
    'LAND',
    'Res Development',
    'RES_DEVELOPMENT',
    'FALSE',
  ],
  [
    'Land: Res House',
    '109',
    'LA',
    '10',
    'Land',
    'LAND',
    'Res House',
    'RES_HOUSE',
    'FALSE',
  ],
  ['Land: Rural', '129', 'LA', '35', 'Land', 'LAND', 'Rural', 'RURAL', 'FALSE'],
  [
    'Land: Rural Acreage',
    '111',
    'LA',
    '30',
    'Land',
    'LAND',
    'Rural Acreage',
    'RURAL_ACREAGE',
    'FALSE',
  ],
  [
    'Storage Unit',
    '125',
    'SU',
    ' ',
    'Storage Unit',
    'STORAGE_UNIT',
    ' ',
    ' NULL',
    'FALSE',
  ],
  [
    'Storage Unit: Car Space',
    '126',
    'SU',
    '10',
    'Storage Unit',
    'STORAGE_UNIT',
    'Car Space',
    'CAR_SPACES',
    'FALSE',
  ],
  [
    'Storage Unit: Storage Locker',
    '127',
    'SU',
    '20',
    'Storage Unit',
    'STORAGE_UNIT',
    'Storage Locker',
    'STORAGE_LOCKER',
    'FALSE',
  ],
  ['Unit', '55', 'UN', ' ', 'Unit', 'UNIT', ' ', ' NULL', 'FALSE'],
  [
    'Unit: Highrise',
    '120',
    'UN',
    '30',
    'Unit',
    'UNIT',
    'Highrise',
    'HIGHRISE',
    'FALSE',
  ],
  [
    'Unit: Lowrise',
    '119',
    'UN',
    '20',
    'Unit',
    'UNIT',
    'Lowrise',
    'LOWRISE',
    'FALSE',
  ],
  [
    'Unit: Penthouse',
    '121',
    'UN',
    '40',
    'Unit',
    'UNIT',
    'Penthouse',
    'PENTHOUSE',
    'FALSE',
  ],
  [
    'Unit: Quadraplex',
    '123',
    'UN',
    '60',
    'Unit',
    'UNIT',
    'Quadraplex',
    'QUADRAPLEX',
    'FALSE',
  ],
  [
    'Unit: Standard',
    '117',
    'UN',
    '5',
    'Unit',
    'UNIT',
    'Standard',
    'STANDARD',
    'FALSE',
  ],
  [
    'Unit: Studio',
    '124',
    'UN',
    '70',
    'Unit',
    'UNIT',
    'Studio',
    'STUDIO',
    'FALSE',
  ],
  [
    'Unit: Townhouse / Villa',
    '118',
    'UN',
    '10',
    'Unit',
    'UNIT',
    'Townhouse / Villa',
    'TOWNHOUSE_VILLA',
    'FALSE',
  ],
  [
    'Unit: Triplex',
    '122',
    'UN',
    '50',
    'Unit',
    'UNIT',
    'Triplex',
    'TRIPLEX',
    'FALSE',
  ],
];

const PropertyTypesTable = () => {
  const [headers, ...rows] = PROPERTY_TYPES;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map(cell => (
              <TableCell
                key={cell}
                sx={{
                  wordBreak: 'normal',
                  overflowWrap: 'normal',
                }}
              >
                {cell}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.toString()}>
              {row.map(cell => (
                <TableCell
                  key={cell}
                  sx={{
                    wordBreak: 'normal',
                    overflowWrap: 'normal',
                  }}
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const PropertyTypesPage = () => {
  const country = useRootStore(state => state.country);

  return (
    <>
      <Helmet>
        <title>
          Guides | Property Types | Cotality Developer Portal |{' '}
          {country.toUpperCase()}
        </title>
      </Helmet>

      <Box flex={1} bgcolor="white">
        <Box maxWidth={1440} m="auto" px={4} pt={4} pb={8}>
          <Typography
            variant="h3"
            fontFamily="TWK Everett"
            fontWeight={600}
            my={0.5}
          >
            Property Types
          </Typography>

          <Typography fontWeight={500}>
            Learn about Cotality Property Types.
          </Typography>

          <br />
          <br />

          <Typography variant="body2">
            Major property types are defined by this list:
          </Typography>

          <br />

          <Accordion>
            <AccordionSummary expandIcon={<ArrowDropDown />}>
              <Typography fontWeight={600}>
                Major Property Types
              </Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails sx={{ p: 0 }}>
              <Stack divider={<Divider flexItem />}>
                {MAJOR_PROPERTY_TYPES.map((type, i) => (
                  <Typography
                    variant="body2"
                    bgcolor={i % 2 === 0 ? '#F8F8F8' : 'white'}
                    px={3}
                    py={2}
                    key={type}
                  >
                    {type}
                  </Typography>
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>

          <br />
          <br />

          <Typography variant="body2">
            Minor property types are defined by this list:
          </Typography>

          <br />

          <Accordion>
            <AccordionSummary expandIcon={<ArrowDropDown />}>
              <Typography fontWeight={600}>Minor Property Types</Typography>
            </AccordionSummary>
            <Divider />
            <AccordionDetails sx={{ p: 0 }}>
              <Stack divider={<Divider flexItem />}>
                {MINOR_PROPERTY_TYPES.map((type, i) => (
                  <Typography
                    variant="body2"
                    bgcolor={i % 2 === 0 ? '#F8F8F8' : 'white'}
                    px={3}
                    py={2}
                    key={type}
                  >
                    {type}
                  </Typography>
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>

          <br />
          <br />

          <Typography variant="h5">Cotality Property Types</Typography>

          <br />

          <PropertyTypesTable />
        </Box>
      </Box>
    </>
  );
};
